import React, { PureComponent } from "react";

type SegmentedControlProps = {
  onChange: (id: string) => void;
  labelOptionOne: string;
  keyOptionOne: string;
  labelOptionTwo: string;
  keyOptionTwo: string;
};

type SegmentedControlState = {
  selectedOption: string;
};

export default class SegmentedControl extends PureComponent<
  SegmentedControlProps,
  SegmentedControlState
> {
  constructor(props: SegmentedControlProps) {
    super(props);

    this.state = {
      selectedOption: this.props.keyOptionOne
    };
  }

  handleOptionChange = (id: string) => {
    this.setState({ selectedOption: id });
    this.props.onChange(id);
  };

  render() {
    const {
      keyOptionOne,
      labelOptionOne,
      keyOptionTwo,
      labelOptionTwo
    } = this.props;
    return (
      <div style={{ display: "flex", flexWrap: "nowrap", flex: "0 0 auto" }}>
        <button
          style={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
          }}
          className={
            this.state.selectedOption === keyOptionOne
              ? "btn btn-sm btn-primary"
              : "btn btn-sm btn-outline-primary"
          }
          id={keyOptionOne}
          onClick={() => this.handleOptionChange(keyOptionOne)}
        >
          {labelOptionOne}
        </button>
        <button
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
          }}
          className={
            this.state.selectedOption === keyOptionTwo
              ? "btn btn-sm btn-primary"
              : "btn btn-sm btn-outline-primary"
          }
          id={keyOptionTwo}
          onClick={() => this.handleOptionChange(keyOptionTwo)}
        >
          {labelOptionTwo}
        </button>
      </div>
    );
  }
}
